<template>
  <FormUpload :doc_number="doc_number" type="QUOTE" id="file-upload-quote" />
</template>

<script>
import FormUpload from '@/components/Form/Upload'
export default {
  components: {
    FormUpload,
  },
  props: {
    doc_number: [String, Number],
  },
}
</script>
